<div class="flex-col">
  <!--show image cropper component if no brand exists-->
  @if (newBrand) {
    <div class="flex-row justify-center">
      @if (imageChangedEvent) {
        <image-cropper class="p-0 new-brand"
          [imageChangedEvent]="imageChangedEvent" format="png" (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"
          [disabled]="!newBrand"
          [maintainAspectRatio]="false"
          [resizeToWidth]="400"
          [resizeToHeight]="300"
          [onlyScaleDown]="true"
        ></image-cropper>
      }
    </div>
  }
  <!--show existing image if a brand exists-->
  @if (!newBrand && brand()?.filePath) {
    <div class="w-100 flex-row justify-center">
      <img class="existing-brand" src="{{existingImage}}" alt="" />
    </div>
  }
  <div class="w-100 flex-row justify-center">
    <a href="#" mat-button class="primary-color" (click)="fileinput.click();$event.preventDefault();">Upload Logo</a>
    <input hidden type="file" accept="image/png, image/jpeg, image/gif" #fileinput (change)="fileChangeEvent($event)">
  </div>
  <div class="w-100 flex-row justify-center">
    <h6 class="text-muted">PNG, JPG and GIF accepted. Larger files will be automatically resized.</h6>
  </div>
</div>